import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.revoke-report-access-grant.UseRevokeReportAccessGrantPresenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage:
      "Unable to remove the user's report access. Please try again.",
  },
})
